import { NAV_CATEGORIES_TOF_ITEM_IS_VIEWED } from './types';

export const triggerNavCategoriesTOFItemView = categoryTitle => ({
  type: NAV_CATEGORIES_TOF_ITEM_IS_VIEWED,
  categoryTitle,
});
